if (window.__ASSETS_PUBLIC_PATH) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__ASSETS_PUBLIC_PATH;
}
